import { UploadStatusType } from '~/enums/UploadStatusType';
import { AlgoStatus, UploadFile } from '~/features/upload/types';
import { pilot } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';
import { PilotId } from '~/types/PilotId';

interface Request {
  page: number;
  pageSize: number;
}

interface Response {
  next: string;
  previous: Nullable<string>;
  count: number;
  results: Array<{
    id: PilotId;
    doc_id: PilotId;
    document_name: string;
    date_added: string;
    size: number;
    file_type: string;
    processing_status: UploadStatusType;
    algo_status_message: Record<string, AlgoStatus>;
  }>;
}

export const getUploadFiles = async ({
  page,
  pageSize,
}: Request): Promise<{ count: number; results: UploadFile[] }> => {
  const queryString = buildQueryString({ page, pageSize });
  const response: Response = await pilot.get(`/user/my-uploads${queryString}`);

  return {
    results: response.results
      ? response.results.map((value) => {
          const algoStatuses = Object.entries(value.algo_status_message).map(
            ([key, value]) => {
              return {
                title: key,
                status: value.status,
                message: value.message,
                count: value.count,
              };
            },
          );
          return {
            id: value.id,
            name: value.document_name,
            //l10n-ignore: API parsing no formatting required
            dateAdded: new Date(value.date_added),
            fileType: value.file_type,
            size: value.size,
            status: value.processing_status,
            algoStatuses: algoStatuses,
          };
        })
      : [],
    count: response.count,
  };
};

const buildQueryString = ({
  page,
  pageSize,
}: {
  page: number;
  pageSize: number;
}): string => {
  const param = [];
  if (page) {
    param.push(`page=${page}`);
  }
  if (pageSize) {
    param.push(`page_size=${pageSize}`);
  }
  return param.length ? `?${param.join('&')}` : '';
};
